export interface IndexRow {
  labelId: string;
  pointsObtained: string | number;
  maxPoints: number;
}

export interface IndexSection {
  titleId: string;
  subtitleId: string;
  rows: IndexRow[];
  total: {
    score: string | number;
    max: number;
  };
}

export const indexData: IndexSection[] = [
  {
    titleId: "page.europe.france_gender_equality_index.europe.title",
    subtitleId: "page.europe.france_gender_equality_index.europe.subtitle",
    rows: [
      {
        labelId: "page.europe.france_gender_equality_index.row.salaryGap",
        pointsObtained: 33,
        maxPoints: 40,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.raiseGap",
        pointsObtained: 20,
        maxPoints: 20,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.promoGap",
        pointsObtained: 15,
        maxPoints: 15,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.maternityReturn",
        pointsObtained: 15,
        maxPoints: 15,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.topSalary",
        pointsObtained: 5,
        maxPoints: 10,
      },
    ],
    total: { score: 88, max: 100 },
  },
  {
    titleId: "page.europe.france_gender_equality_index.west.title",
    subtitleId: "page.europe.france_gender_equality_index.west.subtitle",
    rows: [
      {
        labelId: "page.europe.france_gender_equality_index.row.salaryGap",
        pointsObtained: 39,
        maxPoints: 40,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.raiseGap",
        pointsObtained: "NC",
        maxPoints: 35,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.maternityReturn",
        pointsObtained: "NC",
        maxPoints: 15,
      },
      {
        labelId: "page.europe.france_gender_equality_index.row.topSalary",
        pointsObtained: 0,
        maxPoints: 10,
      },
    ],
    total: { score: "NC", max: 100 },
  },
];
